import { RefObject, useCallback, useEffect, useState } from 'react'

const SCROLL_BUFFER = 5

export function useScroll(ref: RefObject<HTMLDivElement>, paddingTop: number) {
  const [isScrollAtBottom, setIsScrollAtBottom] = useState(false)
  const [isScrolling, setIsScrolling] = useState(false)

  const checkScrollPosition = useCallback(() => {
    const element = ref.current

    if (element) {
      const isNearBottom = element.clientHeight + element.scrollTop >= element.scrollHeight - SCROLL_BUFFER
      setIsScrollAtBottom(!isNearBottom)
      setIsScrolling(element.scrollTop > paddingTop + SCROLL_BUFFER)
    }
  }, [ref, paddingTop])

  useEffect(() => {
    checkScrollPosition()
  }, [checkScrollPosition])

  useEffect(() => {
    const onResize = () => checkScrollPosition()
    const onScroll = () => checkScrollPosition()

    window.addEventListener('resize', onResize)
    ref.current?.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [ref, checkScrollPosition])

  return { isScrollAtBottom, isScrolling }
}
